module.exports = __webpack_public_path__ + "img/款冬花.30ce0d45.jpg";